module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av433-bc98d58178f24769ce9a9b830c45fcf5.jpg";